import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { scrollToId } from "@/lib/scroll";

export const AnchorLink = ({ to, children, className, testId, onDone }) => {
  const { pathname } = useLocation();
  if (pathname === "/") {
    return (
      <button
        type="button"
        data-testid={testId}
        className={className}
        onClick={() => {
          scrollToId(to);
          onDone && onDone();
        }}
      >
        {children}
      </button>
    );
  }
  return (
    <Link to={`/${to}`} data-testid={testId} className={className} onClick={onDone}>
      {children}
    </Link>
  );
};
